import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Container } from './ui/Container';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Is SnoreStop™ uncomfortable to wear?',
  answer: 'Most customers adjust within the first few nights. The adjustable design helps create a more comfortable personalized fit.'
}, {
  question: 'How does SnoreStop™ work?',
  answer: 'SnoreStop™ gently supports the jaw position during sleep which may help reduce airway narrowing associated with snoring.'
}, {
  question: 'How long before people notice a difference?',
  answer: 'Some customers notice quieter nights within the first few uses while others require more adjustment time depending on sleep habits and snoring severity.'
}, {
  question: 'Can I travel with it?',
  answer: 'Yes. Every SnoreStop™ includes a compact travel case making it easy to use during overnight trips and vacations.'
}, {
  question: 'Is this like a CPAP machine?',
  answer: 'No. SnoreStop™ is a lightweight wearable mouthpiece and does not involve machines hoses or noise.'
}, {
  question: 'What if it does not work for me?',
  answer: 'That is exactly why every order includes a 60 Night Money Back Guarantee. You can try it yourself completely risk free.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#FDFBF7] border-t border-gray-100" data-id="element-59">
      <Container data-id="element-60">
        <div className="max-w-3xl mx-auto" data-id="element-61">
          <div className="text-center mb-16" data-id="element-62">
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4" data-id="element-63">
              FAQ
            </h2>
          </div>

          <div className="space-y-4" data-id="element-64">
            {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-id="element-65">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-66">
                  <span className="font-medium text-gray-900 pr-8" data-id="element-67">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-200 flex-shrink-0 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-68" />
                </button>
                <AnimatePresence data-id="element-69">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-70">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-71">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </Container>
    </section>;
}